import {graphql, commitMutation} from 'react-relay';

const mutation = graphql`
    mutation AddCartItemMutation(
        $input: AddCartItemInput!
    ) {
        addCartItem(input: $input) {
            portfolioItems {
                item {
                    itemId
                }
            }
        }
    }
`;

function commit(
    environment,
    {itemIds, onCompleted, onError}
) {
    const variables = {input: {itemIds}};

    commitMutation(
        environment,
        {
            mutation,
            variables,
            onCompleted,
            onError
        }
    );
}

export default {commit};



// WEBPACK FOOTER //
// ./src/mutations/AddCartItemMutation.js